import { render, staticRenderFns } from "./CompanyUploads.vue?vue&type=template&id=e70adaa6&scoped=true"
import script from "./CompanyUploads.vue?vue&type=script&lang=js"
export * from "./CompanyUploads.vue?vue&type=script&lang=js"
import style0 from "./CompanyUploads.vue?vue&type=style&index=0&id=e70adaa6&prod&scoped=true&lang=css"
import style1 from "./CompanyUploads.vue?vue&type=style&index=1&id=e70adaa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70adaa6",
  null
  
)

export default component.exports